/**
 * Shared file-drop overlay shell — used by Vault Upload and Install Module.
 * Parents configure title / prompt / dropzone id; this owns markup structure.
 *
 * Optional `extraBodyHtml` is injected above the dropzone (e.g. Vault key step).
 * Optional `afterDropzoneHtml` is injected below the dropzone.
 * Optional `footerHtml` is placed under the dropzone.
 */
function saitoFileDropOverlay() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    _ref$title = _ref.title,
    title = _ref$title === void 0 ? 'Select File' : _ref$title,
    _ref$prompt = _ref.prompt,
    prompt = _ref$prompt === void 0 ? 'Drag and Drop File to Upload' : _ref$prompt,
    _ref$dropzoneId = _ref.dropzoneId,
    dropzoneId = _ref$dropzoneId === void 0 ? 'saito-file-drop' : _ref$dropzoneId,
    _ref$rootClass = _ref.rootClass,
    rootClass = _ref$rootClass === void 0 ? '' : _ref$rootClass,
    _ref$extraBodyHtml = _ref.extraBodyHtml,
    extraBodyHtml = _ref$extraBodyHtml === void 0 ? '' : _ref$extraBodyHtml,
    _ref$afterDropzoneHtm = _ref.afterDropzoneHtml,
    afterDropzoneHtml = _ref$afterDropzoneHtm === void 0 ? '' : _ref$afterDropzoneHtm,
    _ref$footerHtml = _ref.footerHtml,
    footerHtml = _ref$footerHtml === void 0 ? '' : _ref$footerHtml;
  var footer = footerHtml ? "<div class=\"saito-file-drop-footer\">".concat(footerHtml, "</div>") : '';
  return "\n<div class=\"saito-overlay-form saito-file-drop-overlay ".concat(rootClass, "\">\n  <div class=\"saito-overlay-form-header\">\n    <h2 class=\"saito-overlay-form-header-title\">").concat(title, "</h2>\n  </div>\n  <div class=\"saito-file-drop-body\">\n    ").concat(extraBodyHtml, "\n    <div class=\"saito-file-drop-zone-wrap\">\n      <div class=\"saito-file-dropzone active-tab paste_event\" id=\"").concat(dropzoneId, "\">\n        <i class=\"fa-solid fa-file-arrow-up\" aria-hidden=\"true\"></i>\n        <div class=\"saito-file-dropzone-text\">").concat(prompt, "</div>\n      </div>\n    </div>\n    ").concat(afterDropzoneHtml, "\n  </div>\n  ").concat(footer, "\n</div>");
}
module.exports = {
  saitoFileDropOverlay: saitoFileDropOverlay
};